export default __webpack_public_path__ + "static/media/Noe Text Semibold.c0a3afdd.otf";